const tg = window?.Telegram?.WebApp

export const useTelegram = () => {
	const tgUser = tg?.initDataUnsafe?.user || {
		id: 910589947,
		first_name: 'Abdul Azeez',
		username: 'mielpl',
		last_name: '',
		language_code: 'en',
		allows_write_to_pm: true,
		is_premium: true
	}

	const onClose = () => {
		tg.close()
	}

	return {
		tg,
		tgUser,
		onClose
	}
}
